/* eslint-disable @typescript-eslint/no-explicit-any */

/* eslint-disable @typescript-eslint/no-unsafe-assignment */

/* eslint-disable @typescript-eslint/no-unsafe-argument */
import { useCallback, useEffect, useRef, useState } from 'react';

import { InfiniteData, UseInfiniteQueryResult, UseQueryResult } from '@tanstack/react-query';

// type useFetchAllProps<T = (x: any) => unknown> = {
//   isExporting: boolean;
//   queryFn: T;
//   queryKey: string[];
//   queryS: string;
// };

// In the future we could use this to actually take a generic FN and do all of that work for us
// const useFetchAll = ({ isExporting = false, queryFn, queryKey, queryS }: useFetchAllProps) => {
//   const getQuery = async ({ pageParam = { limit: 100, offset: 0 } }) => {
//     const { queryString } = createQueryOptions<any>({
//       pagination: {
//         limit: pageParam.limit,
//         page: pageParam.offset,
//       },
//       existingSearchString: queryS,
//     });
//     return queryFn({ meta: { queryString } });
//   };

//   return useInfiniteQuery({
//     queryKey: queryKey,
//     queryFn: getQuery,
//     enabled: isExporting,
//     getNextPageParam: (lastPage) => {
//       if (!lastPage) return undefined;
//       const { meta } = lastPage as { meta: RequestMeta };
//       if (!meta) return undefined;
//       const { count, has_more, limit, offset } = meta;
//       if (!has_more) {
//         return undefined;
//       }
//       return { limit, offset: offset + count };
//     },
//   });
// };

type ExportQueryTData = { data: unknown };
type ExportQuery<TData extends ExportQueryTData> = UseInfiniteQueryResult<TData, unknown>;

type ExportQueryFn<TData extends ExportQueryTData> = ({
  isExporting,
  queryOptions,
  settings,
}: {
  isExporting: boolean;
  queryOptions?: any;
  settings?: any;
}) => ExportQuery<TData>;

type UseExportQuery<TData extends ExportQueryTData> = {
  useExportFn: ExportQueryFn<TData>;
  queryOptions?: any;
  settings?: any;
  onComplete?: (data: TData) => void;
};

const useExportQuery = <TQuery extends ExportQueryTData, TResponse extends ExportQuery<TQuery>>({
  useExportFn,
  queryOptions,
  settings,
}: UseExportQuery<TQuery>) => {
  const exportCallbackRef = useRef<(data: any) => void>();
  const [exporting, setExporting] = useState(false);
  const result = useExportFn({
    isExporting: exporting,
    queryOptions,
    ...settings,
  });
  const { data, fetchNextPage, hasNextPage, isFetching } = result ?? { data: [] };

  useEffect(() => {
    if (exporting) {
      if (hasNextPage) {
        try {
          // eslint-disable-next-line @typescript-eslint/no-floating-promises -- The async portion is handled via the useExportFn
          fetchNextPage();
        } catch {
          // Do nothing
        }
      } else if (!isFetching) {
        setExporting(false);

        exportCallbackRef.current?.(data);
      }
    }
  }, [hasNextPage, exporting, isFetching, fetchNextPage, data]);

  const startExport = useCallback((callback?: (queryData: TResponse['data']) => void) => {
    exportCallbackRef.current = callback;
    setExporting(true);
  }, []);

  const formatExportData = (data?: InfiniteData<TResponse>) =>
    data?.pages?.flatMap((page) => page.data);

  return { data, startExport, exporting, isFetching, formatExportData };
};

export { useExportQuery };
export type { ExportQueryFn, ExportQueryTData, UseQueryResult };
